import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
} from 'reactstrap';

import { getPaymentList, setPaymentCancelled } from '../../../../slices/thunks';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { setRequireCloseModal } from '../../../../slices/payment/reducer';

const DeletePaymentModal = ({ dataPayment, isOpen, handleToggleModalDelete, setDataPayment }) => {
	const dispatch = useDispatch();
	const [isDeleting, setIsDeleting] = useState(false);

	const selectorSensor = createSelector(
		state => state.Payments,
		payment => ({
			isPaymentSuccess: payment.isPaymentSuccess,
			requireCloseModal: payment.requireCloseModal,
		})
	);

	const { isPaymentSuccess, requireCloseModal } = useSelector(selectorSensor);

	useEffect(() => {
		if (isOpen && requireCloseModal) {
			dispatch(setRequireCloseModal(false));
			handleToggleModalDelete();
		}
	}, [requireCloseModal, isOpen, dispatch, handleToggleModalDelete]);

	// Maneja la acción de eliminar el pago
	const handlerDelete = async () => {
		setIsDeleting(true);
		try {
			const result = await dispatch(setPaymentCancelled(dataPayment._id));

			if (result && result.payload) {
				await dispatch(getPaymentList());
			}
		} catch (error) {
			console.error("Error al intentar cancelar el pago:", error);
		} finally {
			dispatch(setRequireCloseModal(false))
			setIsDeleting(false);
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			toggle={() => handleToggleModalDelete()}
			size="sm"
			className="border-0"
			modalClassName="modal fade zoomIn"
			backdrop="static"
			centered
		>
			<ModalHeader className="modal-title" />
			<ModalBody className="text-center p-3">
				<lord-icon
					src="https://cdn.lordicon.com/tdrtiskw.json"
					trigger="loop"
					colors="primary:#f06548,secondary:#405189"
					style={{ width: '90px', height: '90px' }}
				></lord-icon>
				<div className="mt-2">
					<h3 className="mb-3">¡Estás a punto de cancelar un Estado de Pago!</h3>
					<p className="text-muted mb-4">
						Si deseas realizar esta acción debes hacer click en confirmar.
					</p>
					<p className="small">
						Estado de Pago: {dataPayment ? dataPayment.code : ''}
					</p>
					<div className="hstack gap-2 justify-content-center">
						<Button
							className="btn-danger btn-label"
							onClick={handleToggleModalDelete}
							disabled={isDeleting}
						>
							<i className="icon-x label-icon"></i> Cancelar
						</Button>
						<button
							className="btn btn-label btn-primary"
							onClick={() => handlerDelete()}
							disabled={isDeleting}
						>
							{isDeleting ? (
								<i className="label-icon">
									<Spinner size="sm" />
								</i>
							) : (
								<i className={`${Icons.check2} label-icon`}></i>
							)}{' '}
							Confirmar
						</button>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default DeletePaymentModal;
